/**
 * Carrega um script dinamicamente no DOM.
 * Se a variavel global ja existir no window, resolve imediatamente.
 * Timeout padrao: 10 segundos.
 */
export function loadScript(url: string, globalVar?: string, timeout = 10000): Promise<unknown> {
  return new Promise((resolve, reject) => {
    if (globalVar && (window as any)[globalVar]) {
      resolve((window as any)[globalVar]);
      return;
    }

    const script = document.createElement('script');
    script.src = url;
    script.async = true;

    const timeoutId = setTimeout(() => {
      cleanupScript(script);
      reject(new Error(`Timeout ao carregar script: ${url}`));
    }, timeout);

    script.onload = () => {
      clearTimeout(timeoutId);
      if (globalVar && (window as any)[globalVar]) {
        resolve((window as any)[globalVar]);
      } else {
        resolve(undefined);
      }
    };

    script.onerror = () => {
      clearTimeout(timeoutId);
      cleanupScript(script);
      reject(new Error(`Erro ao carregar script: ${url}`));
    };

    document.head.appendChild(script);
  });
}

function cleanupScript(script: HTMLScriptElement): void {
  if (script.parentNode) {
    script.parentNode.removeChild(script);
  }
}
